import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import AdminCustomFields from '../../../../containers/Admin/CustomFields';
import AdminCustomFieldEdit from '../../../../containers/Admin/CustomFieldEdit';

const SettingsCustomFieldsContent = (props) => {
  const { activeTab, activeSubTab } = props;
  const { customFieldId } = useParams();

  if (activeTab === 'custom-fields') {
    if (!activeSubTab && !customFieldId) return <AdminCustomFields />;

    if (activeSubTab === 'add' || customFieldId) return <AdminCustomFieldEdit />;
  }

  return null;
};

SettingsCustomFieldsContent.propTypes = {
  activeTab: PropTypes.string,
  activeSubTab: PropTypes.string,
};

SettingsCustomFieldsContent.defaultProps = {
  activeTab: null,
  activeSubTab: null,
};

export default SettingsCustomFieldsContent;
